import { Hotel, Car, Phone, MapPin, Globe } from "lucide-react";
import { stayLists, mapsUrl } from "@/lib/api";

const Row = ({ label, value }) => value ? (
  <div className="flex justify-between gap-4 border-b border-[var(--line)] py-3 text-[15px] last:border-0">
    <span className="text-slate-500">{label}</span><span className="text-right">{value}</span>
  </div>
) : null;

const fmt = (d) => (/^\d{4}-\d{2}-\d{2}$/.test(d || "") ? new Date(`${d}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : d);

const Head = ({ icon: I, title }) => <div className="mb-3 flex items-center gap-2 text-[var(--gold-deep)]"><I size={18} /><span className="eyebrow">{title}</span></div>;

const HotelCard = ({ h, i }) => (
  <div className="ivory-card p-6" data-testid={`stay-hotel-card-${i}`}>
    <Head icon={Hotel} title={h.city ? `Hotel \u00b7 ${h.city}` : "Hotel"} />
    <div className="font-serif-d text-2xl">{h.name || "To be confirmed"}</div>
    {h.address && <a href={h.map_link || mapsUrl(`${h.name || ""} ${h.address}`)} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center gap-2 text-sm text-slate-600 hover:underline" data-testid={`stay-hotel-map-${i}`}><MapPin size={14} className="text-[var(--gold-deep)]" />{h.address}</a>}
    {h.website && <a href={h.website.startsWith("http") ? h.website : `https://${h.website}`} target="_blank" rel="noreferrer" className="mt-1 flex items-center gap-2 text-sm text-slate-600 hover:underline" data-testid={`stay-hotel-website-${i}`}><Globe size={14} className="text-[var(--gold-deep)]" />Website</a>}
    <div className="mt-3"><Row label="Room" value={h.room} /><Row label="Check-in" value={fmt(h.check_in)} /><Row label="Check-out" value={fmt(h.check_out)} /></div>
  </div>
);

const TransferCard = ({ t, i }) => (
  <div className="ivory-card p-6" data-testid={`stay-transfer-card-${i}`}>
    <Head icon={Car} title={t.city ? `Transfer \u00b7 ${t.city}` : "Transfer"} />
    {(t.date || t.time) && <div className="font-serif-d text-2xl">{[fmt(t.date), t.time].filter(Boolean).join(" \u00b7 ")}</div>}
    {t.pickup && <a href={t.pickup_map || mapsUrl(t.pickup)} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center gap-2 text-sm text-slate-600 hover:underline" data-testid={`stay-transfer-map-${i}`}><MapPin size={14} className="text-[var(--gold-deep)]" />Pick-up: {t.pickup}</a>}
    <div className="mt-3"><Row label="Vehicle" value={t.vehicle} /><Row label="Cab ID" value={t.cab_number} /><Row label="Driver" value={t.driver_name} /><Row label="Driver mobile" value={t.driver_mobile} /></div>
    {t.transfer_info && <p className="mt-3 whitespace-pre-line text-[15px] leading-relaxed text-slate-700">{t.transfer_info}</p>}
    {t.driver_mobile && <a href={`tel:${t.driver_mobile.replace(/[^\d+]/g, "")}`} className="btn-ink mt-4 w-full" data-testid={`call-driver-btn-${i}`}><Phone size={15} /> Call driver</a>}
  </div>
);

export default function StayView({ stay }) {
  const { hotels, transfers } = stayLists(stay);
  if (!hotels.length && !transfers.length) return <p className="ivory-card p-6 text-slate-600" data-testid="stay-pending">Your hotel and transfer details will appear here once confirmed by the team.</p>;
  return (
    <div className="grid gap-5 sm:grid-cols-2">
      {hotels.map((h, i) => <HotelCard key={`h${i}`} h={h} i={i} />)}
      {transfers.map((t, i) => <TransferCard key={`t${i}`} t={t} i={i} />)}
    </div>
  );
}
